import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CancelGRContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  width: '100%',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },

  '.btnContainer': {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    marginTop: '10px'
  }
})